import React from 'react'

import ToastMessage from '../components/ToastMessage/ToastMessage'
import { toast } from 'react-toastify'
import ToastCheckboxes from '../components/ToastCheckboxes/ToastCheckboxes'

export const hideBodyScroll = () => {
  if (typeof window !== 'undefined') {
    document.getElementsByTagName('body')[0].style.overflow = 'hidden'
  }
}

export const showBodyScroll = () => {
  if (typeof window !== 'undefined') {
    document.getElementsByTagName('body')[0].style.overflow = 'auto'
  }
}

export const CustomToast = (toastLabel) => {
  setTimeout(toast.dismiss(), 15000)
  return toast(<ToastMessage toastLabel={toastLabel} />, {
    position: 'top-center',
    hideProgressBar: true,
    closeButton: true,
  })
}

export const CustomToastCheckboxes = (
  toastLabel,
  state,
  formName,
  handleCleanup
) => {
  setTimeout(toast.dismiss(), 15000)
  return toast(
    <ToastCheckboxes
      toastLabel={toastLabel}
      state={state}
      formName={formName}
      handleCleanup={handleCleanup}
    />,
    {
      position: 'top-center',
      hideProgressBar: true,
      closeButton: false,
      autoClose: false,
      closeOnClick: false,
      draggable: false,
    }
  )
}

let options = {
  notation: 'compact',
  compactDisplay: 'short',
}
export const formatCmpctNumber = (number) => {
  const usformatter = Intl.NumberFormat('en-US', options)
  return usformatter.format(number)
}
